export default __webpack_public_path__ + "e58d2e09e24c8a0c43e6baa5158b29b0.png";